var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleLoading = function SvgCircleLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    fillOpacity: 0.5,
    d: "M34.5 69C53.554 69 69 53.554 69 34.5S53.554 0 34.5 0 0 15.446 0 34.5 15.446 69 34.5 69",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C29B40",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M45.5 21.135v4.307a.432.432 0 0 1-.764.276 13.7 13.7 0 0 0-10.243-4.583c-7.59 0-13.743 6.156-13.743 13.75 0 5.442 3.16 10.146 7.745 12.375M34.865 48.635q-.964 0-1.893-.127m14.913-18.207q.232.82.365 1.653M48.203 37q-.146.826-.377 1.632m-2.096 4.498q-.492.73-1.065 1.4m-3.88 3.226q-.73.418-1.517.753"
  })));
};
export default SvgCircleLoading;